import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import PopoverComponent from "core/gd-components/base-component/popover-component";
import Popover from "core/gd-components/gd-popover/popover";
import FieldsFactory1 from "../../../../fields-factory";

export default class FormulaInListWithPopover extends PopoverComponent {

    static propTypes = {
        invalidFormulaLabel: PropTypes.string,
        invalidValueLabel: PropTypes.string
    }

    static defaultProps = {
        invalidFormulaLabel: 'Invalid formula',
        invalidValueLabel: 'Invalid value'
    };

    onSave = (value) => {
        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            if (this.props.onChange) this.props.onChange(value);
        })
    }

    renderPopover() {
        if (this.state.showPopover) {
            const Field = FieldsFactory1.get(this.props.id);

            return (
                <Popover popoverClass="gd-field-formula-edit-popover"
                         className="gd-field-formula-edit-popover-container"
                         attachment={this.props.attachment ? this.props.attachment : 'top center'} //defaultProps somehow doesn't work
                         targetAttachment={this.props.targetAttachment ? this.props.targetAttachment : 'bottom center'}
                         targetOffset={this.props.targetOffset}
                         attachmentType={this.props.attachmentType ? this.props.attachmentType : 'horizontal'}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    {Field.getFormulaWithValues(this.props.item)}

                </Popover>
            );
        }
    }

    render() {
        const Field = FieldsFactory1.get(this.props.id);
        const value = Field.getValue(this.props.item);
        const currencyMark = Field.getCurrencyMark();
        const postfix = Field.getPostfix()
        const decimalPlaces = Field.getDecimalPlaces();
        const isValid = Field.isFormulaValid();

        const classes = Classes(this.props.className, {
            'invalid-formula': !isValid
        });

        const showCurrency = isValid && currencyMark && !_.isNil(value);
        let valueLabel;
        if (!isValid)               valueLabel = this.props.invalidFormulaLabel;
        else if (_.isNil(value))    valueLabel = this.props.invalidValueLabel;
        else if (showCurrency)      valueLabel = gd.utils.Format.currency(value, decimalPlaces, true);
        else                        valueLabel = gd.utils.Format.number(value, decimalPlaces, false);

        return (
            <div className={classes} onClick={this.props.canEdit === false ? null : this.togglePopover}>
                <div className="content">
                    {showCurrency && <div className="currency-mark">{currencyMark}</div>}
                    {valueLabel}
                    {postfix}
                </div>
                {this.renderPopover()}
            </div>
        )
    }
}
